// App.js
import React, { useState } from 'react';
import { useNavigate, BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
// import LandingPage from './Components/LandingPage';
// import Login from './Components/Login'

import Dashboard from './Dashboard';
import Navbar from './Components/Navbarr';
import PersonalDetails from './Components/PersonalDetails';
import CommunicationDetails from './Components/CommunicationDetails';
import RegisterUser from './Components/Master/RegisterUser';
import AddressDetails from './Components/AddressDetails';
import EducationDetails from './Components/EducationDetails';
import SalaryDetails from './Components/SalaryDetails';
import Home from './Components/Home';
import Signup from './Components/Signup';
import EmployeeList from './Components/EmployeeList';
import EditEmployee from './Components/EditEmployee';
import ProductPage from './Components/ProductPage';
import ChatBot from 'react-chatbotify';
import Otherservices from './Components/Master/Otherservices';
import CategoryMaster from './Components/Master/CategoryMaster';
import PlanMaster from './Components/Master/PlanMaster';
import PlanMasternew from './Components/Master/PlanMasterNew';
import TermsConditions from './Components/Master/TermsConditions';
import KeywordManager from './Components/Master/KeywordManager';
import Addproof from './Components/Master/Addproof';
import Priority from './Components/Master/Priority';
import Entryimageupload from './Components/Image_Upload/Entryimageupload';
import Exitimageupload from './Components/Image_Upload/Exitimageupload';
import TeamMaster2 from './Components/TeamMaster2';
import FinalDetails from './Components/FinalDetails';
import MyAccount from './Components/MyAccount';
import LoginPage from './Components/Loginpage'
import GroupView from './Components/Transactions/Groupbyusers'
import DateWiseGroup from './Components/Transactions/DateWiseGroup'
import Registeredusers from './Components/Transactions/Registeredusers';
import ToBeVerified from './Components/Transactions/To_be_verfied';
import ToBekycVerified from './Components/Transactions/ToBekycVerified';
import VerifiedUsers from './Components/Transactions/verifiedusers';
import VerifiedInactiveUsers from './Components/Transactions/inactiveusers';
import PayPending from './Components/Transactions/Payment_pending_user';
import Paymentfollowupusers from './Components/Transactions/Paymentfollowup';
import SearchUser from './Components/Report/SearchUser';
import ExpireSearchUser from './Components/Report/ExpireSearchUser';
import ExpiredUserSearch from './Components/Report/ExpiredSearchUser';
import TotalPlanReport from './Components/Report/TotalPlanReport';
import LiveUserReport from './Components/Report/LiveUserReport';
import PaidUserReport from './Components/Report/PaidUserReport';
import ExpiryShowReport from './Components/Report/ExpiryShowReport';
import PaymentFailure from './Components/Report/PaymentFailureReport';
import TotalRegisteredUsers from './Components/Report/TotalRegisteredUsers';
import AccountReport from './Components/Report/AccountsReport';
import Feedback from './Components/Report/FeedbackReport';
import ViewCount from './Components/Report/ViewCount';
import AppPaidUsersReport from './Components/Report/AppPaidUsersReport';
import DeletedUsersTable from './Components/Report/DeletedUsers';
import AddFollowupUsers from './Components/Report/AddFollowupUsers';
import ViewFollowupUsers from './Components/Report/ViewFollowupUsers';
// import DownloadLiveUsersRep from './Components/Report/DownloadLiveUsersRep';
import DownloadMobileNumber from './Components/Report/DownloadMobileNumber';
import DownloadedMobileNumber from './Components/Report/DownloadedMobileNumber';
import PaidExpiredFollowups from './Components/Report/Paid_plan_expired_report';
import FreePlanExpiredFollows from './Components/Report/free_plan_expired_followup';
import RegistrationForm from './Components/Master/RegistrationForm';
import PaymentPlans from './Components/Master/PaymentPlans';
import AddPaymentPlan from './Components/Master/paymentplan'
import UpdatePaymentPlans from './Components/Master/UpdatePlan';
import Updationplan from './Components/Master/Updationplan';
import RegistrationFormnew from './Components/Master/RegistrationFormnew'
import HomeSlider from './Components/Master/HomeSlider'
import EnquiryFollowUp from './Components/Report/EnquiryFollowUp'
import EnquiryReport from './Components/Report/EnquiryReport'
import Enquiry from './Components/Report/enquiry'
import ChatbotReport from './Components/Report/chatbotReport';
import AddPaymentPlanJathagam from './Components/Master/paymentplanjathagam';
import ViewPaymentPlanJathagam from './Components/Master/Viewpaymentplanjathagam';
import Writtenjathagamcount from './Components/Master/writtenjathagamcount';
import OtherPayment from './Components/Master/Otherpaymentform';
import OtherPaymentService from './Components/Master/Otherpaymentservice';
import Other_payments from './Components/Master/Other_payments';
// import OtherPayment from './Components/Report/OtherPaymentReport';
import OtherPaymentReport from './Components/Master/OtherPaymentReport';
import OtherPaymentServiceCount from './Components/Master/OtherPaymentServiceCount'
import EnquiryDeleteReport from './Components/Report/EnquiryDeleteReport'
// import PaymentFailureReport from './Components/Report/PaymentFailureReport'
import Womensdaypayment from './Components/Master/Womensdaypaymentform';



function Register() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);

  const [formData, setFormData] = useState({
    employeeCode: '',
    fingerprintID: '',
    name: '',
    designation: '',
    dateOfBirth: '',
    dateOfJoining: '',
    dateOfRelease: '',
    maritalStatus: '',
    gender: '',
    bloodGroup: '',
    fatherOrHusbandName: '',
    eStatus: '',
    companyEmail: '',
    personalEmail: '',
    primaryMobile: '',
    contactPersonPrimary: '',
    secondaryMobile: '',
    contactPersonSecondary: '',
    additionalMobile: '',
    contactPersonAdditional: '',
    presentAddress: '',
    permanentAddress: '',
    qualification: '',
    institution: '',
    certificates: '',
    previousExperience: '',
    grossSalary: '',
    esi: '',
    pf: '',
    netSalary: '',
    pfNumber: '',
    esiNumber: '',
    uan: '',
    teamname: '',
    passwordnew: '',
  });

  const handleNext = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handlePrev = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch('http://localhost:3001/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        console.log('Form submitted successfully!');
        navigate('/employees'); // Redirect to employee list after successful submission
      } else {
        console.log('Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <>
      {currentStep === 1 && (
        <PersonalDetails
          nextStep={handleNext}
          prevStep={handlePrev}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {currentStep === 2 && (
        <CommunicationDetails
          prevStep={handlePrev}
          nextStep={handleNext}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {currentStep === 3 && (
        <AddressDetails
          prevStep={handlePrev}
          nextStep={handleNext}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {currentStep === 4 && (
        <EducationDetails
          prevStep={handlePrev}
          nextStep={handleNext}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {currentStep === 5 && (
        <SalaryDetails
          prevStep={handlePrev}
          nextStep={handleNext}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {currentStep === 6 && (
        <FinalDetails
          prevStep={handlePrev}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleSubmit} // Submit on final step
        />
      )}
    </>
  );
}

function AppContent() {
  const [sidebar, setSidebar] = useState(false);
  const location = useLocation(); // Correctly used within Router context

  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  // List of routes where the Navbar should not be displayed
  const noNavbarRoutes = ['/'];

  return (

    
    <div className={`flex bg-white-50 ${sidebar ? 'ml-64' : 'ml-0'} transition-all duration-300`}>
      {/* Conditionally render Navbar */}
      {!noNavbarRoutes.includes(location.pathname) && ( 
        
        <Navbar sidebar={sidebar} toggleSidebar={toggleSidebar} />
      )}

<div className={`flex-1 ${!noNavbarRoutes.includes(location.pathname) ? 'mt-16' : ''}`}> 
<Routes>


          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<Dashboard />} /> 
          {/* <Route path="/signup" element={<Signup />} /> */}
          {/* <Route path="/master/login" element={<Login />} /> */}
          <Route path="/home" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/employees" element={<EmployeeList />} />
          <Route path="/edit/:id" element={<EditEmployee />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/master/otherservices" element={<Otherservices/>} />
          <Route path="/master/category_master" element={<CategoryMaster />} />
          <Route path="/master/plan_master" element={<PlanMaster />} />
          <Route path="/master/plan-master-new" element={<PlanMasternew />} />
          <Route path="/master/registration_form" element={<RegistrationForm />} />
          <Route path="/master/registration_form_new" element={<RegistrationFormnew />} />
          <Route path="/master/choose_payment_plan" element={<AddPaymentPlan/>  }/>
          <Route path="/master/update_user" element={<RegisterUser />} />
          <Route path="/master/update_payment_plan" element={<Updationplan/>  }/>
          <Route path="/master/terms_conditions" element={<TermsConditions />} />
          <Route path="/master/keyword" element={<KeywordManager />} />
          <Route path="/master/add_proof" element={<Addproof />} />
          <Route path="/master/Priority" element={<Priority />} />
          <Route path="/Entry_image_upload" element={<Entryimageupload />} />
          <Route path="/Exit_image_upload" element={<Exitimageupload />} />
          <Route path="/team-master2" element={<TeamMaster2 />} />
          <Route path="/support" element={<ChatBot />} />
          <Route path="/MyAccount" element={<MyAccount />} />
          <Route path="/transactions/GroupView" element={<GroupView />} />  
          <Route path="/transactions/DateWiseGroup" element={<DateWiseGroup />} />
          <Route path="/transactions/Registeredusers" element={<Registeredusers />} />
          <Route path="/transactions/ToBeVerified" element={<ToBeVerified />} />
          <Route path="/transactions/ToBekycVerified" element={<ToBekycVerified />} />
          <Route path="/transactions/verified-users" element={<VerifiedUsers />} />
          <Route path="/transactions/inactive-users" element={<VerifiedInactiveUsers />} />

          <Route path="/transactions/paymentpending" element={<PayPending />} />
          <Route path="/transactions/paymentfollowup" element={<Paymentfollowupusers />} />
          <Route path="/reports/SearchUser" element={<SearchUser />} />
          <Route path="/reports/ExpireSearchUser" element={<ExpireSearchUser />} />
          <Route path="/reports/ExpiredUserSearch" element={<ExpiredUserSearch />} />
          {/* <Route path="/reports/payment-failure-report" element={<PaymentFailureReport />} /> */}
          <Route path="/master/home_slider" element={<HomeSlider />} />      
          <Route path="/reports/total-registered-users" element={<TotalRegisteredUsers />} />
         <Route path="/reports/total-plan-report" element={<TotalPlanReport />} /> 
         <Route path="/reports/live-user-report" element={<LiveUserReport />} /> 
         <Route path="/reports/paid-user-report" element={<PaidUserReport />} />
         <Route path="/reports/expiry-show-report" element={<ExpiryShowReport />} />
         <Route path="/reports/payment-failure-report" element={<PaymentFailure />} />
<Route path="/reports/accounts-report" element={<AccountReport />} />
<Route path="/reports/feedback-report" element={<Feedback />} />
<Route path="/reports/view-count" element={<ViewCount />} />
<Route path="/reports/app-paid-users-report" element={<AppPaidUsersReport />} />
<Route path="/reports/deleted-users" element={<DeletedUsersTable />} />
<Route path="/reports/downloaded-mobile-number" element={<DownloadedMobileNumber />} /> 
<Route path="/reports/add-followup-users" element={<AddFollowupUsers />} />
<Route path="/reports/download-mobile-number" element={<DownloadMobileNumber />} />
<Route path="/reports/view-followup-users" element={<ViewFollowupUsers />} />
<Route path="/reports/paidexpiredfollowups" element={<PaidExpiredFollowups />} />
<Route path="/reports/freeexpiredfollowups" element={<FreePlanExpiredFollows />} />
<Route path="/reports/enquiry" element={<Enquiry />} />
<Route path="/reports/enquiryfollowups" element={<EnquiryFollowUp />} />
<Route path="/reports/enquiry-report" element={<EnquiryReport />} />
<Route path="/reports/chatbot_report" element={<ChatbotReport/>}/>
<Route path="/reports/payment_plan_jathagam" element={<AddPaymentPlanJathagam/>}/>
<Route path="/reports/view_payment_plan_jathagam" element={<ViewPaymentPlanJathagam/>}/>
<Route path="/reports/Writtenjathagamcount" element={<Writtenjathagamcount/>}/>
<Route path="/reports/Other_payment" element={<OtherPayment/>}/>
<Route path="/reports/Other_payment_service" element={<OtherPaymentService/>}/>
<Route path="/reports/other_payments" element={<Other_payments/>}/>
<Route path="/master/other_payment_report" element={<OtherPaymentReport/>}/>
<Route path="/master/other_payment_service_count" element={<OtherPaymentServiceCount/>}/>
<Route path="/reports/enquiry_delete_report" element={<EnquiryDeleteReport/>}/>
<Route path="/reports/womens_day" element={<Womensdaypayment/>}/>


{/*
<Route path="/reports/app-paid-users-report" element={<AppPaidUsersReport />} />
<Route path="/reports/deleted-users" element={<DeletedUsers />} />
<Route path="/reports/add-followup-users" element={<AddFollowupUsers />} />
<Route path="/reports/view-followup-users" element={<ViewFollowupUsers />} />
<Route path="/reports/download-live-users-report" element={<DownloadLiveUsersRep />} />
<Route path="/reports/download-mobile-number" element={<DownloadMobileNumber />} />
<Route path="/reports/downloaded-mobile-number" element={<DownloadedMobileNumber />} />   */}

        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;


